import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { toJS } from "mobx";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { Input, Label, Utils } from "arv-reactcomponents";
import { scrollTime } from "../../../../constants";
import BodyOverlay from "../../../BodyOverlay";
import Analytics from "../../../../analytics";
import Event from "../../../../analytics/eventFactory";

import { getFilterUrl } from "../../../../utils";

@withRouter
@inject("ProductStore")
@observer
class SortByView extends Component {
  static currentClass(sort) {
    return sort.isSelected ? "is-selected" : "";
  }
  constructor() {
    super();
    this.sortClick = this.sortClick.bind(this);
  }
  get sortBy() {
    return toJS(this.props.ProductStore.ProductData.sorts);
  }
  sortClick(sortBySelected) {
    if (sortBySelected.isSelected) {
      return null;
    }
    const { pathname, search } = this.props.location;
    const pagePath = `${pathname}${search}`;
    const { ProductStore } = this.props;

    ProductStore.setListingPageNo(1);
    const pathWithPageNo = Utils.setUrlParameter(pagePath, "p", 1);

    const filterUrl = getFilterUrl(
      sortBySelected,
      ProductStore.ProductData.sorts.mapping,
      pathWithPageNo,
    );
    const newUrl = `${pathname}?${filterUrl}`;
    this.props.ProductStore.toggleMobileFilters(
      this.props.ProductStore.mobileFilterToggle.activeFilter,
    );

    ProductStore.getAllProductData(newUrl).then(() => {
      Utils.scrollTo(window, 0, 100, scrollTime.fast);
      BodyOverlay.hide();
    });
    const state =
      (this.props.history &&
        this.props.history.location &&
        this.props.history.location.state) ||
      {};
    this.props.history.replace(newUrl, state);

    BodyOverlay.show();
    Analytics.trackEvent({
      action: Event.action.getSortType(sortBySelected.value),
      category: Event.category.LISTING_PAGE,
    });
    return null;
  }
  render() {
    return (
      <form className="nw-mobilefilters-sortview">
        <h1 className="nw-mobilefilters-sortview-heading">Sort By:</h1>
        <ul className="nw-mobilefilters-sortview-list">
          {this.sortBy.list.map(sort => (
            <li
              className={`nw-mobilefilters-sortview-listitem ${SortByView.currentClass(
                sort,
              )}`}
              key={sort.value}
            >
              <Label htmlFor={`nw-mobilefilters-sortview${sort.value}`}>
                <Input
                  id={`nw-mobilefilters-sortview${sort.value}`}
                  type="checkbox"
                  value={sort.value}
                  className="nw-mobilefilters-sortview-checkbox"
                  checked={sort.isSelected || false}
                  name={sort.displayName}
                  onChange={() => {
                    this.sortClick(sort);
                  }}
                />
                <span>{sort.displayName}</span>
              </Label>
            </li>
          ))}
        </ul>
      </form>
    );
  }
}

SortByView.wrappedComponent.propTypes = {
  ProductStore: PropTypes.shape({
    setListingPageNo: PropTypes.func.isRequired,
    toggleMobileFilters: PropTypes.func.isRequired,
    mobileFilterToggle: PropTypes.shape({
      activeFilter: PropTypes.string.isRequired,
    }).isRequired,
    ProductData: PropTypes.shape({
      sorts: PropTypes.shape([]).isRequired,
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
    location: PropTypes.shape({
      state: PropTypes.shape({}).isRequired,
    }).isRequired,
  }).isRequired,
};
export default SortByView;



// WEBPACK FOOTER //
// ./src/component/MobileFilters/FilterViews/SortByView/index.js